<template>
<div class="px-10 container" role="document">
  <main class="wrapper" role="main">
    <div class="row no-gutter header" style="background-color:#044e51;">
      <div class="col-12">
        <img
          src="https://dellpartnerincentives.com/siteassets/Images/DNCP/Q3FY27/header3.gif"
          alt="Turn everyday deals into more with RISE!"
          border="0"
          style="width:100%;max-width:1280px;display:flex;"
        >
      </div>
    </div>

    <div class="row no-gutter content" style="background-color:#f1f1f1;color:#1d2c3b;padding:20px 0px;">
      <div class="col-1">&nbsp;</div>
      <div class="col-10">
        <div class="spacer" style="padding: 20px 0px;">
          <div style="width: 36px; height: 10px; background-color: #044e52;"></div>
        </div>
        <p class="intro-paragraph">
          Enjoy more savings with up to <strong>40% off Dell Displays and PC Accessories,</strong> and <strong>more rewards</strong> every time you
          <strong>purchase RISE-eligible products.</strong>
        </p>
        <p class="intro-paragraph">
          From high-resolution monitors and seamless docking to essential accessories, Dell solutions are built to keep
          work moving.
        </p>
      </div>
      <div class="col-1">&nbsp;</div>
    </div>

    <div class="row no-gutter" style="background-color:#f1f1f1;">
      <div class="col-1"></div>
      <div class="col-10">
        <div class="row no-gutter promo-row" style="color:#ffffff;">
          <div class="col-2">
            <div style="background-color:#0b7c84;min-height:80px;text-align:center;">
              <img
                src="https://dellpartnerincentives.com/siteassets/Images/DNCP/Q3FY27/device-monitor.gif"
                alt=""
                style="width:80%;max-width:80px;vertical-align:middle;display:inline-block;"
              >
            </div>
          </div>
          <div class="col-10">
            <div class="promo-text" style="background-color:#0b7c84;min-height:80px;color:#ffffff;vertical-align:middle;">
              <a href="https://www.dellpartnerincentives.com/resources/DnCP%20Promotions.pdf" target="_blank" style="color:#ffffff;font-size:20px;">Explore</a>
              Dell’s range of Displays and PC Accessories promotions.
            </div>
          </div>
        </div>
      </div>
      <div class="col-1"></div>
    </div>

    <div class="row no-gutter" style="background-color:#f1f1f1;">
      <div class="col-1">&nbsp;</div>
      <div class="col-10">
        <div style="padding:20px;">
          <p style="font-size:66%;text-align:center;color:#1d2c3b;">
            *Available in: United Kingdom, France, Germany, Ireland, Spain, Italy, Portugal, Belgium, Netherlands, Sweden, Denmark, Finland, Norway, Austria, Switzerland.
          </p>
        </div>
      </div>
      <div class="col-1">&nbsp;</div>
    </div>
  </main>

  <footer class="row no-gutter footer" style="background-color:#ffffff;" align="center">
    <div style="font-size:66%;color:#1d2c3b;font-weight:300;padding:30px 20px;text-align:center;width:100%;">
      Copyright © 2026 Dell Inc. or its subsidiaries. All Rights Reserved. Dell Technologies, Dell, and other trademarks are trademarks of Dell Inc. or its subsidiaries.
      <br>
      Other trademarks may be trademarks of their respective owners.
    </div>
  </footer>
</div>


</template>

<script setup>

</script>

<style scoped>
      H1{
      color:#e5f8ff;
      font-weight:700;
      font-size:24px;
      }
      a{
      color:#1d56c0;
      font-weight:700;
      font-size:18px;
      }
      html {
      box-sizing: border-box;
      height: 100vh;
      }
      *,
      *:before,
      *:after {
      box-sizing: inherit;
      }
      .wrapper {
      _position: relative;
      }
      /**
      * Fluid grid system
      */
      /* 100% width container */
      .container {
      margin: 0 auto;;
      padding: 0 48px;
      width: 100%;
      /* max-width: 1280px !important; */
      list-style: none;
      min-height: 100vh;
      display: flex;
      flex-direction: column;
      font-size: 20px;
      font-family: 'Roboto', sans-serif;
      color: #1d2c3b;
      background-color: #ffffff;
      font-weight: 400;
      }

      .intro-paragraph {
        line-height: 1.55;
        margin: 0 0 20px 0;
      }

      .promo-row {
        margin-top: 12px;
      }

      .promo-text {
        padding: 24px 16px 16px 24px;
      }
      /* Give `.wrapper` a maximum width and center it within its parent*/
      .wrapper {
      margin: 0 auto;
      width: 100%;
      max-width: 1280px;
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      /* max-width: 1280px !important; */
      }
      .header {
        flex: 0 0 auto;
      }
      .footer {
        flex: 0 0 auto;
      }
      /* Don't honor column widths until viewport is at least 600px wide */
      @media (min-width: 600px) {
      .row {
      margin-right: -1.333%;
      margin-left: -1.333%;
      }
      [class^="col-"],
      [class*=" col-"]{
      position: relative;
      float: left;
      padding-right: 1.333%;
      padding-left: 1.333%;
      min-height: 1px;
      width: 100%;
      }
      /* Remove space between `.col-*` elements with `.no-gutter` class */
      .row.no-gutter {
      margin-left: 0;
      margin-right: 0;
      }
      .row.no-gutter [class^="col-"] {
      padding-left: 0;
      padding-right: 0;
      }
      /* Column widths */
      .col-1  { width: 8.333%;  }
      .col-2  { width: 16.666%; }
      .col-3  { width: 25%;     }
      .col-4  { width: 33.333%; }
      .col-5  { width: 41.666%; }
      .col-6  { width: 50%;     }
      .col-7  { width: 58.333%; }
      .col-8  { width: 66.666%; }
      .col-9  { width: 75%;     }
      .col-10 { width: 83.333%; }
      .col-11 { width: 91.666%; }
      .col-12 { width: 100%;    }
      /* Push & pull */
      .push-1  { left: 8.333%;  }
      .push-2  { left: 16.666%; }
      .push-3  { left: 25%;     }
      .push-4  { left: 33.333%; }
      .push-5  { left: 41.666%; }
      .push-6  { left: 50%;     }
      .push-7  { left: 58.333%; }
      .push-8  { left: 66.666%; }
      .push-9  { left: 75%;     }
      .push-10 { left: 83.333%; }
      .push-11 { left: 91.666%; }
      .push-12 { left: 100%;    }
      .pull-1  { right: 8.333%;  }
      .pull-2  { right: 16.666%; }
      .pull-3  { right: 25%;     }
      .pull-4  { right: 33.333%; }
      .pull-5  { right: 41.666%; }
      .pull-6  { right: 50%;     }
      .pull-7  { right: 58.333%; }
      .pull-8  { right: 66.666%; }
      .pull-9  { right: 75%;     }
      .pull-10 { right: 83.333%; }
      .pull-11 { right: 91.666%; }
      .pull-12 { right: 100%;    }
      }

       @media (max-width: 600px) {
      .container {
        padding: 0 16px;
      }
      .content p {
        padding: 20px;
      }
      .promo-text {
        padding: 18px 16px;
      }
       }

      /* Clear floats */
      .container:before,
      .container:after,
      .wrapper:before,
      .wrapper:after,
      .row:before,
      .row:after {
      display: table;
      content: " ";
      }
      .container:after,
      .wrapper:after,
      .row:after {
      clear: both;
      }
   </style>